<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="172" height="133" viewBox="0 0 172 133" fill="none">
    <path
      d="M108.491 39.79V130.931H2V2H70.7755L108.491 39.79Z"
      fill="white"
      stroke="#293D66"
      stroke-width="2.78296"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M108.72 39.79H71.0044V2"
      stroke="#293D66"
      stroke-width="2.78296"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6704 54.1592H76.3531"
      stroke="#293D66"
      stroke-width="2.78296"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6704 27.2847H43.0746"
      stroke="#293D66"
      stroke-width="2.78296"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6704 41.0864H43.0746"
      stroke="#293D66"
      stroke-width="2.78296"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6704 66.5801H77.7547"
      stroke="#293D66"
      stroke-width="2.78296"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6704 79.1147H77.7547"
      stroke="#293D66"
      stroke-width="2.78296"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M170 108C171.105 108 172 107.105 172 106C172 104.895 171.105 104 170 104L170 106L170 108ZM74.5858 104.586C73.8047 105.367 73.8047 106.633 74.5858 107.414L87.3137 120.142C88.0948 120.923 89.3611 120.923 90.1421 120.142C90.9232 119.361 90.9232 118.095 90.1421 117.314L78.8284 106L90.1421 94.6863C90.9232 93.9052 90.9232 92.6389 90.1421 91.8579C89.3611 91.0768 88.0948 91.0768 87.3137 91.8579L74.5858 104.586ZM170 106L170 104L76 104L76 106L76 108L170 108L170 106Z"
      fill="#4200FF"
      fill-opacity="0.94"
    />
  </svg>
</template>
